import React from 'react';
import Stepper from '../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../components/Onboarding/8figExplanation/8FigExplanation';
import { is8DataApp, providerName } from '../../utils';

export default function EightFigExplanation() {
  const HEADER_8FIG =
    'You’re an 8-figure seller in the making. We can help get you there.';
  const HEADER_8DATA = `${providerName} unlocks your business capabilities with connected planning and analytics`;

  return (
    <>
      <Stepper
        title={is8DataApp() ? HEADER_8DATA : HEADER_8FIG}
        headerWidth={600}
        contentWidth={600}
        showLoading={false}
      >
        <PageLayout />
      </Stepper>
    </>
  );
}
